import {
  SORTED_COLOR_DTOS,
  translateColorLabel,
} from '@components/announcement/util/announcementColorSwatch.util';
import { AnnouncementBriefDTO, colorDtoToLabel, RasterFontDTO } from '@/model';
import { FormField, FormFieldType } from '@/type';
import { mapToSelectOptions } from '@/util';
import {
  numberLessThanValidator,
  numberPositiveValidator,
  requiredStringValidation,
} from '@/constant';
import { t } from 'i18next';

const colorOptions = SORTED_COLOR_DTOS.map((color) => ({
  value: color,
  label: translateColorLabel(colorDtoToLabel(color), t),
}));

export const layoutEditorAnnouncementModalFormFields = (
  fetchedAnnouncements: AnnouncementBriefDTO[],
  fetchedRasterFonts: RasterFontDTO[],
  LOGICAL_WIDTH: number,
  LOGICAL_HEIGHT: number,
): FormField[] => [
  {
    type: FormFieldType.Select,
    name: 'announcementId',
    label: 'common.announcement',
    options: mapToSelectOptions(fetchedAnnouncements),
    validation: requiredStringValidation(),
    xs: 6,
  },
  {
    type: FormFieldType.Select,
    name: 'rasterFontId',
    label: 'announcements.table.header.raster-font',
    options: mapToSelectOptions(fetchedRasterFonts),
    validation: requiredStringValidation(),
    xs: 6,
  },
  {
    type: FormFieldType.Select,
    name: 'fontColor',
    label: 'announcements.table.header.font-color',
    options: colorOptions,
    validation: requiredStringValidation(),
    xs: 6,
  },
  {
    type: FormFieldType.Select,
    name: 'backgroundColor',
    label: 'announcements.table.header.background-color',
    options: colorOptions,
    validation: requiredStringValidation(),
    xs: 6,
  },
  {
    type: FormFieldType.Number,
    name: 'width',
    label: 'common.width',
    placeholder: t('layout.modal.width-placeholder'),
    postFix: 'px',
    validation: numberPositiveValidator().concat(numberLessThanValidator(LOGICAL_WIDTH)),
    xs: 6,
  },
  {
    type: FormFieldType.Number,
    name: 'height',
    label: 'common.height',
    placeholder: t('layout.modal.height-placeholder'),
    postFix: 'px',
    validation: numberPositiveValidator().concat(numberLessThanValidator(LOGICAL_HEIGHT)),
    xs: 6,
  },
];
